import { render, staticRenderFns } from "./PreviewRatingAttribute.vue?vue&type=template&id=76d2f8e3&scoped=true"
import script from "./PreviewRatingAttribute.vue?vue&type=script&lang=js"
export * from "./PreviewRatingAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d2f8e3",
  null
  
)

export default component.exports